import classnames from "classnames";
import { RichText } from "prismic-reactjs";
import React, { useState } from "react";
import { translate } from "src/services/translation.service";
import theme from "src/theme";
import { IPrimaryModal } from "src/types/prismic";
import styled from "styled-components";

import { Popin } from "..";

interface IButton {
  background: string;
  color: string;
}

const Button = styled.button<IButton>`
  && {
    color: ${({ color }: IButton): string => color};
    background: ${({ background }: IButton): string => background};
    border: 1px solid ${({ background }: IButton): string => background};
    padding: ${theme.margins.paddingPage} ${theme.margins.paddingPageXBig};
    margin: ${theme.margins.marginBase};

    &:hover {
      color: ${theme.colors.black};
      background: ${theme.colors.white};
    }
  }
`;

const Header = styled.header`
  margin: ${theme.margins.marginBase} 0;
  font-family: ${theme.fonts.subtitle};
  font-size: ${theme.fontSizes.big};
  border-bottom: 1px solid ${theme.colors.veryLightGrey};
`;

const Body = styled.section``;

const Footer = styled.footer`
  border-top: 1px solid ${theme.colors.veryLightGrey};
`;

interface IProps {
  className?: string;
  background?: string;
  data: IPrimaryModal;
}

const ModalButton = ({
  setOpen,
  content,
  background = theme.colors.black,
  color = theme.colors.white,
  className,
}): JSX.Element => {
  let element = <span>{translate("modal.button.defaultText")}</span>;

  if (content && content[0].text !== "") {
    if (content.length === 1 && content[0].type === "paragraph") {
      content[0].type = "label";
    }

    element = <RichText render={content} />;
  }

  return (
    <Button
      className={className}
      background={background}
      color={color}
      onClick={(): void => setOpen((cur) => !cur)}
    >
      {element}
    </Button>
  );
};

const Content = ({ header, body, footer }): JSX.Element => (
  <>
    {header[0].text && (
      <Header className="modal-header">
        <RichText render={header} />
      </Header>
    )}
    <Body className="modal-body">
      <RichText render={body} />
    </Body>
    {footer[0].text && (
      <Footer className="modal-footer">
        <RichText render={footer} />
      </Footer>
    )}
  </>
);

const PrismicPopin = ({ className, background, data }: IProps): JSX.Element => {
  const {
    classnames: ModalButtonClassnames,
    modal_button_background: buttonBackground,
    modal_button_color: buttonColor,
    modal_button_content: buttonContent,
    modal_header: header,
    modal_body: body,
    modal_footer: footer,
  } = data;

  const [open, setOpen] = useState<boolean>(false);

  return (
    <>
      {/* TODO: all images content in button should be max-width: 100% */}
      <ModalButton
        setOpen={setOpen}
        content={buttonContent}
        background={buttonBackground}
        color={buttonColor}
        className={classnames("modal-opener", className, ModalButtonClassnames)}
      />
      {open && (
        <Popin
          onClose={(): void => setOpen((cur) => !cur)}
          isOpen={open}
          className="cms-modal"
          background={background}
        >
          <Content header={header} body={body} footer={footer} />
        </Popin>
      )}
    </>
  );
};

export default PrismicPopin;
